import styled from "styled-components";

export const Button = styled.button<{
  primary?: boolean;
  disableHover?: boolean;
}>`
  background: ${props => (props.primary ? "black" : "white")};
  color: ${props => (props.primary ? "white" : "black")};

  font-weight: 900;
  font-size: 1em;
  margin: 1em;
  padding: 1.8rem 1.9rem;
  // border: 2px solid black;
  // border-radius: 3px;
  border: 0;

  transition: all 0.35s ease-in-out;
  &:hover {
    background: ${props =>
      !props.disableHover && props.primary ? "#a6a6a6" : "black"};
    color: ${props =>
      !props.disableHover && props.primary ? "white" : "white"};
    cursor: pointer;
  }
`;
